import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const getClinics = ({ lat, lng, assessments }) => {
    const params = new URLSearchParams();

    if (!!lat) params.append("lat", lat);
    if (!!lng) params.append("lng", lng);
    if (!!assessments) params.append("assessments", assessments);

    return axios
        .get(`/wp-json/api/adpt/clinics?${params.toString()}`)
        .then((res) => res?.data);
};

export default function useClinics({
    lat,
    lng,
    assessments,
    enabled = true,
    onSuccess,
}) {
    return useQuery(
        ["clinics", { lat, lng, assessments }],
        () => getClinics({ lat, lng, assessments }),
        {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            enabled,
            onSuccess: (data) => onSuccess && onSuccess(data),
        }
    );
}
